import { current } from '@reduxjs/toolkit';
import actions from './actions';

const {
  GET_MOVEMENTS,
  SET_MOVEMENTS,
  GET_MOVEMENTS_BEGIN,
  GET_MOVEMENTS_FINISH,
  SET_CURRENT_PAGE,
} = actions;

const initialState = {
  data: [],
  loading: false,
  totalItems: 0,
  currentPage: 1,
};

const movementsReducer = (state = initialState, action: any) => {
  const { type, data, page } = action;
  switch (type) {
    case GET_MOVEMENTS:
      return {
        ...state,
      };
    case SET_MOVEMENTS:
      return {
        ...state,
        data: Array.isArray(data?.data) ? data.data : [],
        totalItems: typeof data?.totalItems === 'number' ? data.totalItems : 0,
        currentPage: typeof data?.currentPage === 'number' ? data.currentPage : 1,
        loading: false,
      };
    case GET_MOVEMENTS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_MOVEMENTS_FINISH:
      return {
        ...state,
        loading: false,
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: page,
      };
    default:
      return state;
  }
};

export { movementsReducer };
